import server from '../api/server';

export class UserInfoService {
    static async getUser(token: string, id: number): Promise<any> {
        const headers = {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        };

        try {
            const responseServer = await server.get(
              `staff/customer/${id}`,
              {headers}
            );

            return responseServer.data.data;
        } catch (error: any) {
            throw new Error(error.response.status);
        }
    }
}
